import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const TraditionalIRA: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 24 24" strokeWidth={0} {...props}>
            <mask
                id="mask0_234_16947"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" rx="12" fill="currentColor" />
            </mask>
            <g mask="url(#mask0_234_16947)">
                <IconPath
                    d="M14.1045 -6.39844L-5.64638 13.3524"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M16.0479 -4.45508L-3.70302 15.2958"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M19.9326 -0.570312L0.181746 19.1806"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M23.8184 3.31641L4.06749 23.0673"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M17.9902 -2.51367L-1.76064 17.2372"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M21.876 1.37109L2.12511 21.122"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M25.7607 5.25977L6.00987 25.0106"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M27.7041 7.20312L7.95323 26.954"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
                <IconPath
                    d="M29.6465 9.14453L9.89561 28.8954"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    {...pathProps}
                />
            </g>
        </IconSVG>
    );
};
